/* =========================================================================
   COMPONENT: ATELIER MODAL (Takeover Logic - iOS Scroll Safe)
   ========================================================================= */
window.AtelierModalUI = (function() {
  var lockedScrollY = 0;
  var currentVariantId = null;

  function init() {
    var modal = document.getElementById('AtelierModal');
    if (!modal) return;

    // General Modal Click Logic (Tabs, Close, etc)
    modal.addEventListener('click', function(e) {
      var target = e.target;
      
      if (target.tagName.toLowerCase() === 'a' && target.getAttribute('href') === '#') {
        e.preventDefault();
      }

      if (target.closest('.atelier-modal__close') || target === modal || target.closest('.atelier-modal__img')) {
        e.preventDefault(); 
        closeModal();
      }
      
      var tabBtn = target.closest('.atelier-modal__tab');
      if (tabBtn) {
        e.preventDefault();
        switchTab(tabBtn.dataset.modalTab);
      }
      
      if (target.closest('.js-modal-switch-origin')) {
        e.preventDefault();
        switchTab('origin');
      }
    });
  }

  function openModal(wrap, view) {
    var modal = document.getElementById('AtelierModal');
    var dataEl = wrap.querySelector('.js-card-data');
    if (!modal || !dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } 
    catch(e) { console.error('Atelier: JSON parse failed', e); return; }

    var card = wrap.querySelector('.atelier-card') || wrap;
    currentVariantId = card.dataset.variantId || wrap.dataset.variantId;

    document.getElementById('AtelierModalName').textContent = data.title;
    
    var modalImg = document.getElementById('AtelierModalImg');
    if (data.image) {
      modalImg.src = data.image;
      modalImg.style.display = 'block';
    } else {
      modalImg.style.display = 'none';
    }

    var learnHtml = data.description ? `<div class="atelier-modal__desc">${data.description}</div>` : '';
    
    // SAFE PARSING: Handle the allergen whether it arrives as an array or a string
    var parsedAllergens = Array.isArray(data.allergensString) ? data.allergensString.join(', ') : data.allergensString;
    if (parsedAllergens && parsedAllergens.trim() !== '') {
      learnHtml += `<p class="atelier-modal__desc">Contains: ${parsedAllergens}</p>`;
    }
    
    if (data.cacaos && data.cacaos.length) {
      learnHtml += `<span class="atelier-modal__label" style="margin-top:1rem;display:block;">Cacao</span>
        <div style="display:flex;flex-wrap:wrap;gap:0.5rem;margin-top:0.5rem;">
          <button class="atelier-modal__cacao js-modal-switch-origin" type="button">
            <span>${data.cacaos.map(c => c.name).join(' &middot; ')}</span>
          </button>
        </div>`;
    }
    document.getElementById('AtelierModalViewLearn').innerHTML = learnHtml;

    var originHtml = '';
    if (data.cacaos) {
      originHtml = data.cacaos.map((c, i) => {
        var couvertureParts = [];
        if (c.name) couvertureParts.push(c.name);
        if (c.percentage) couvertureParts.push(c.percentage + '%');
        if (c.type) couvertureParts.push(c.type);
        var couvertureStr = couvertureParts.join(' ');

        var originParts = [];
        if (c.origin_country) originParts.push(c.origin_country);
        if (c.region) originParts.push(c.region);
        var originStr = originParts.join(' &bull; ');

        var formatNotes = function(notes) {
          if (!notes) return '';
          if (typeof notes === 'string' && notes.trim().startsWith('[')) {
            try { notes = JSON.parse(notes); } catch(e) {}
          }
          if (Array.isArray(notes)) return notes.join(' &bull; ');
          return String(notes).replace(/,\s*/g, ' &bull; '); 
        };

        var primaryNotes = c.primary_tasting_notes || c.primaryTastingNotes || c.primary_notes || c.primaryNotes;
        var secondaryNotes = c.secondary_tasting_notes || c.secondaryTastingNotes || c.secondary_notes || c.secondaryNotes;
        var variety = c.bean || c.variety;

        return `
        <div class="atelier-card__panel-origin">
          ${couvertureStr ? `<span class="atelier-modal__label">Couverture</span><p class="atelier-modal__desc">${couvertureStr}</p>` : ''}
          ${originStr ? `<span class="atelier-modal__label">Origin</span><p class="atelier-modal__desc">${originStr}</p>` : ''}
          ${variety ? `<span class="atelier-modal__label">Cacao</span><p class="atelier-modal__desc">${variety}</p>` : ''}
          ${primaryNotes ? `<span class="atelier-modal__label">Primary notes</span><p class="atelier-modal__desc">${formatNotes(primaryNotes)}</p>` : ''}
          ${secondaryNotes ? `<span class="atelier-modal__label">Secondary notes</span><p class="atelier-modal__desc">${formatNotes(secondaryNotes)}</p>` : ''}
          ${c.description ? `<div class="atelier-modal__desc" style="margin-top: 1.5rem; line-height: 1.5;">${c.description}</div>` : ''}
        </div>
        ${i < data.cacaos.length - 1 ? '<hr class="atelier-card__panel-divider">' : ''}
        `;
      }).join('');
    }
    document.getElementById('AtelierModalViewOrigin').innerHTML = originHtml;

    var ingrHtml = data.hasIngredients && data.ingredientsHtml ? `<div class="atelier-card__panel-ingr">${data.ingredientsHtml}</div>` : '';
    document.getElementById('AtelierModalViewIngr').innerHTML = ingrHtml;

    document.getElementById('AtelierModalTabs').querySelectorAll('.atelier-modal__tab').forEach(t => {
      var tv = t.dataset.modalTab;
      // UX FIX: Ensure the Learn tab shows if there is a description OR an allergen string
      var hasLearnContent = data.description || (parsedAllergens && parsedAllergens.trim() !== '');
      t.style.display = (tv === 'learn' && hasLearnContent) || (tv === 'origin' && data.cacaos) || (tv === 'ingr' && data.hasIngredients) ? '' : 'none';
    });

    switchTab(view || 'learn');
    
    clearError();
    
    modal.querySelector('.atelier-modal__scroll').scrollTop = 0;
    lockedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    
    modal.classList.add('is-open');

    // Prompt the generic global widget script to sync the modal UI to the current selection state!
    document.dispatchEvent(new CustomEvent('AtelierBuilder:QtyChanged'));
  }

  function switchTab(view) {
    document.getElementById('AtelierModalTabs').querySelectorAll('.atelier-modal__tab').forEach(t => {
      t.classList.toggle('is-active', t.dataset.modalTab === view);
    });
    document.getElementById('AtelierModalViewLearn').style.display  = view === 'learn'  ? '' : 'none';
    document.getElementById('AtelierModalViewOrigin').style.display = view === 'origin' ? '' : 'none';
    document.getElementById('AtelierModalViewIngr').style.display   = view === 'ingr'   ? '' : 'none';
  }

  function closeModal() {
    var modal = document.getElementById('AtelierModal');
    if (!modal) return;
    
    clearError();
    
    modal.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    
    window.requestAnimationFrame(function() {
      window.scrollTo(0, lockedScrollY);
    });

    currentVariantId = null;
  }
  
  // --- PUBLIC ERROR API (Relied on by atelier-qty-widget.js) ---
  function showError(msg) {
    var errorNode = document.getElementById('AtelierModalErrorMsg');
    var addBtn = document.getElementById('AtelierModalAddBtn');
    var counter = document.getElementById('AtelierModalCounter');

    if (errorNode) {
      errorNode.innerHTML = msg; 
      errorNode.style.display = 'block';
    }
    
    // Shake whichever button is currently visible
    var targetShake = (addBtn && addBtn.style.display !== 'none') ? addBtn : counter;
    if (targetShake) {
      targetShake.classList.add('atelier-shake-error');
      setTimeout(function() { targetShake.classList.remove('atelier-shake-error'); }, 400);
    }
  }

  function clearError() {
    var errorNode = document.getElementById('AtelierModalErrorMsg');
    var addBtn = document.getElementById('AtelierModalAddBtn');
    var counter = document.getElementById('AtelierModalCounter');
    
    if (errorNode) {
      errorNode.style.display = 'none';
      errorNode.innerHTML = '';
    }
    if (addBtn) addBtn.classList.remove('atelier-shake-error');
    if (counter) counter.classList.remove('atelier-shake-error');
  }

  function getCurrentVariant() { return currentVariantId; }

  return { init, openModal, closeModal, switchTab, getCurrentVariant, showError, clearError };
})();

if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', window.AtelierModalUI.init); } 
else { window.AtelierModalUI.init(); }